import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import { DialogModule } from 'primeng/dialog';
import { Component, AfterViewInit, Input, OnInit } from '@angular/core';
/*
			<div [ngClass]={doNotCreate:!active||!goodUrl} style="padding-left: 25px"><img src={{legendUrl}} width="200"></div>
        <img [src]="imageSrc" class="checkboxDivImage" style="max-width: 200px;" />
      */

@Component({
  selector: 'app-single-legend',
  template: `
			<div [ngClass]="{'doNotCreate':!active||!goodUrl}" style="padding-left: 25px">
        <img [src]="imageSrc" class="checkboxDivImage" style="max-width: 200px;" (click)="showLargeImage()"/>
      </div>
      <p-dialog [(visible)]="displayLarge"><img [src]="imageSrc"></p-dialog>
  `,
	styleUrls: ['app.component.css']
})
export class SingleLegendComponent implements OnInit {

	@Input() active: boolean = false;
	@Input() legendUrl: string = '';

  goodUrl = false;   // local variable indicating whether the legendUrl is valid
  imageSrc;
  displayLarge = false;

  constructor(private http:HttpClient, private sanitizer: DomSanitizer ) { }

  ngOnInit(): void {
  }

	// elements referred to in ViewChild are not reliably available  until ngAfterViewInit so shouldn't be referenced in ngOnInit
  ngAfterViewInit() {
    // console.log(this.active, this.legendUrl);
    if ( this.legendUrl != '' && this.legendUrl != undefined ) {
      this.fileExists(this.legendUrl).subscribe( results => {
        this.goodUrl = results;
        // console.log(this.legendUrl, results);
      });
    } 
  }

  // Check if file exists (and store it for future use)
  // Went through all of this because the FEMA floodplain was taking so long to return but this didn't help any.
  // Deciding to store all legends in the image directory since they rarely change.
  // see https://stackoverflow.com/questions/51019467/convert-blob-to-image-url-and-use-in-image-src-to-display-image
  fileExists(url: string): Observable<boolean> {
    return this.http.get(this.legendUrl, {responseType: 'blob'})
      .pipe(
        tap((x) => {
          const self = this;
          let reader = new FileReader();
          reader.readAsDataURL(x);
          reader.onloadend = function() {
            // const base64data = reader.result;
            // self.imageSrc = self.sanitizer.bypassSecurityTrustUrl('data:image/png;base64,' + base64data);
            self.imageSrc = reader.result;
          }
        }
        ),
        map((x => true), catchError(e => of(false))));
  }

    showLargeImage() {
      this.displayLarge = true;
    }
}
